<template>
  <p class="clearfix mb-0">
    <span class="float-md-right d-block d-md-inline-block mt-25">
      کلیه حقوق متعلق به مجموعه
      <b-link
        class=""
        href=""
        target="_blank"
      >{{ $themeConfig.app.appName}} </b-link>
      <span class="d-none d-sm-inline-block">می‌باشد.</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import {$themeConfig} from "@themeConfig";

export default {
  computed: {
    $themeConfig() {
      return $themeConfig
    }
  },
  components: {
    BLink,
  },
}
</script>
